import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Box } from '../../layout';
import { BaseInput } from './base_input';
import Label from '../../typography/label';
import { AppText } from '../../typography';
import { markRequired } from '../../../util/mark_required';
import { useTheme } from '../../../styles';
import { FocusWithinContainer } from '../focus_within_container';
import { Row } from '../../layout/flex';
import styled from '../../../styles/styled';
import { CopyButton } from '../../buttons';
const PasswordVisibilityToggle = styled(AppText)({
    padding: '12px',
    '&:hover': {
        cursor: 'pointer',
    },
});
export const WhiteInput = ({ name, type, label, value, hideLabel, required, labelSize = 'large', labelColor = 'light', error, status, copyToClipboard, readOnly, helpText, ...rest }) => {
    const theme = useTheme();
    const [showInput, setShowInput] = useState(false);
    const testIdLabel = label?.replace(/\s+/g, ' ').split(' ').join('-').toLowerCase();
    const displayError = () => {
        if (error) {
            return error;
        }
        else if (status && name === 'password') {
            return status;
        }
        else {
            return '';
        }
    };
    const isText = (showInput && type === 'password') || !type;
    return (_jsxs(Box, { flexGrow: 1, children: [_jsx(Box, { children: _jsx(Label, { size: labelSize, capitalize: true, htmlFor: name, screenReaderOnly: hideLabel, color: labelColor, headingFontFamily: true, children: markRequired(required, label) }) }), _jsx(FocusWithinContainer, { mt: 3, mb: 3, children: _jsxs(Row, { width: '100%', bg: 'white', height: '40px', borderRadius: '2px', fontSize: 1, border: error || status
                        ? `solid 1px ${theme.colors.red50}`
                        : `solid 1px ${theme.colors.grey90}`, children: [_jsx(BaseInput, { id: name, name: name, label: label, pl: 3, backgroundColor: 'white', borderRadius: '2px', fontSize: 1, value: value, readOnly: readOnly, ...rest, type: isText ? 'text' : type }), type === 'password' && (_jsx(PasswordVisibilityToggle, { color: 'medium', size: 'small', onClick: () => {
                                setShowInput(!showInput);
                            }, children: showInput ? 'hide' : 'show' })), copyToClipboard && (_jsx(CopyButton, { "data-testid": "copy-button", value: `${value}`, label: `Copy text ${value} to clipboard` }))] }) }), helpText && (_jsx(Box, { mt: 1, style: { marginBottom: '16px' }, children: _jsx(AppText, { as: 'p', size: 'small', color: 'medium', children: helpText }) })), required && !error && (_jsx(Box, { mt: 1, style: { marginBottom: '16px' }, children: _jsx(AppText, { as: 'p', size: 'small', color: 'medium', "data-testid": `validation-message-for-${testIdLabel}`, children: `*${label} is required` }) })), !readOnly && (error || (status && type === 'password')) && (_jsx(Box, { mt: 1, style: { marginBottom: '16px' }, children: _jsx(AppText, { as: 'p', size: 'small', color: 'red50', "data-testid": `validation-error-for-${testIdLabel}`, children: displayError() }) }))] }));
};
//# sourceMappingURL=white_input.js.map